import React, {Fragment} from "react";
import ListView from "../../../components/ContentDisplay/ListView";
import AddUser from "../../../components/Modal/AddUser";
import DeleteModal from "../../../components/Modal/DeleteModal";
import {useUserSearchOptions} from "./useUserSearchOptions";
import {useUserTableActions} from "./useUserTableActions";
import {useUserTableData} from "./useUserTableData";
import UserCard from "./userCard";
import {ACTIONS_LIST, LIST_HEADERS, PERMS_FOR_ACTIONS} from "./userTable.constants";
import "./userTable.scss";

const UsersTable = () => {
  const {searchOptions} = useUserSearchOptions();
  const {fetchAfterDelete, handleSearch, paginationConfig, usersList, userTotalCount} =
    useUserTableData();
  const {
    closeDeleteModal,
    closeEditModal,
    handleActionSelection,
    handleDelete,
    isDeleteModalOpen,
    isEditModalOpen,
    selectedRow,
  } = useUserTableActions(fetchAfterDelete);

  return (
    <Fragment>
      {isEditModalOpen && (
        <AddUser data={selectedRow} onCancel={closeEditModal} open={isEditModalOpen} />
      )}
      {isDeleteModalOpen && (
        <DeleteModal
          header={"Delete User"}
          modalBody={"Are you sure you want to delete this user ?"}
          onClose={closeDeleteModal}
          onDelete={handleDelete}
          open={isDeleteModalOpen}
        />
      )}
      <div className="table-container">
        <ListView
          listItems={usersList}
          listHeaders={LIST_HEADERS}
          onSelectAction={handleActionSelection}
          withActions
          actionsList={ACTIONS_LIST}
          permsForActions={PERMS_FOR_ACTIONS}
          totalCount={userTotalCount}
          withPagination={paginationConfig}
          withSearchQuery={true}
          searchPlaceHolder={"Filter Users"}
          searchOptions={searchOptions}
          handleSearch={handleSearch}
          cardContent={UserCard}
        />{" "}
      </div>
    </Fragment>
  );
};

export default UsersTable;
